import { Component, Vue, Prop, Watch, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import ErrorAlert from '@/components/errors/ErrorAlert.vue';
import AddonItem from '@/components/addons/AddonItem.vue';
import DonationInput from '@/components/inputs/donation/DonationInput.vue';
import QuantityInput from '@/components/inputs/quantity/QuantityInput.vue';
import ValidationErrors from '@/components/errors/ValidationErrors.vue';
import '@/common/filters/AllFiltersExport';
import { DtoEventRegistration, EventRegistration } from '../../common/types/event/DtoEventRegistration';
import { DtoCurrentUser } from '@/common/types/user/DtoCurrentUser';
import triggerPopover from '../directives/triggerPopover-directive';
import PhoneInput from '@/components/inputs/phone/PhoneInput.vue';
import { ApiErrorResponse } from '../../common/types/AllTypesExports';
import { AxiosResponse } from 'axios';
import { customerRepo } from '../../common/repositories/CustomerRepo';

Validator.localize('en', {
    custom: {
        guest_name: { noAt: 'The "@" character is not allowed in Name field.' },
        guest_company: { noAt: 'The "@" character is not allowed in Parent Name field.' }
    }
});

@Component({
    name: 'EventGuestForm',
    components: {
        ErrorAlert,
        ValidationErrors,
        AddonItem,
        DonationInput,
        QuantityInput,
        PhoneInput
    },
    directives: {
        triggerPopover
    }
})
export default class EventGuestForm extends Vue {
    @Prop({ required: false })
    attendeeIndex!: number;

    @Prop({ required: true })
    isAttendeeCentered!: boolean;

    @Prop({ required: true })
    isLoading!: boolean;

    @Prop({ required: false, default: () => false })
    parentRequired!: boolean;

    @Prop({ required: false, default: () => 'Parent Member' })
    parentLabel!: string;

    @Prop({ required: true })
    registration!: DtoEventRegistration;

    @Inject('user')
    currentUser!: DtoCurrentUser;

    @Inject('validator')
    $validator: any;

    duplicateAlreadyHasAccount = false;
    showModal = false;

    created() {
        this.$validator.extend('noAt', {
            validate: (v: string) => !/@/.test(v || '')
        });
    }

    login() {
        window.location.href = "/login?returnUrl=" + window.location.pathname;
    }

    continueAsGuest() {
        this.showModal = false;
    }

    checkForDuplicateEmail() {
        this.validateEmailAddress();
    }

    onGuestEmailChanged() {
        this.checkForDuplicateEmail();
    }

    validateEmailAddress() {
        // Call the API to check for a duplicate email among users and members/customers
        return customerRepo.checkForDuplicate(this.registration.guestEmail ?? "", '', '', null) // probably don't coalesce here
            .then((result) => {
                if (result.hasDuplicate) {
                    if (result.customerId) {
                        this.duplicateAlreadyHasAccount = true;
                        this.showModal = true;
                    }
                }

                return result;
            })
            .catch((error: AxiosResponse<ApiErrorResponse>) => {
                this.errors.add({ field: 'account_email', id: 'account_email', msg: error.data.message });
                return error;
            });
    }
}
